"use client";

import { useTranslation } from "react-i18next";

export const useMobileFooterConfig = () => {
  const { t } = useTranslation();
  return [
    {
      title: t("indexPage.footer-menu.products.text"),
      items: [
        {
          title: t("indexPage.footer-menu.products.items.0.text"),
          external: false,
          route: "https://marinade.finance/stake/?input=SOL",
        },
        {
          title: t("indexPage.footer-menu.products.items.1.text"),
          external: false,
          route: "https://marinade.finance/learn/cookbook",
        },
        {
          title: t("indexPage.footer-menu.products.items.2.text"),
          external: false,
          route: "https://marinade.finance/network",
        },
      ],
    },
    {
      title: t("indexPage.footer-menu.governance.text"),
      items: [
        {
          title: t("indexPage.footer-menu.governance.items.0.text"),
          external: false,
          route: "https://marinade.finance/mnde",
        },
        {
          title: t("indexPage.footer-menu.governance.items.1.text"),
          external: true,
          route: "https://app.realms.today/dao/MNDE",
        },
        {
          title: t("indexPage.footer-menu.governance.items.2.text"),
          external: true,
          route: "https://forum.marinade.finance/",
        },
      ],
    },
    {
      title: t("indexPage.footer-menu.learn.text"),
      items: [
        {
          title: t("indexPage.footer-menu.learn.items.0.text"),
          external: true,
          route: "https://docs.marinade.finance",
        },
        {
          title: t("indexPage.footer-menu.learn.items.1.text"),
          external: false,
          route: "https://marinade.finance/blog",
        },
        {
          title: t("indexPage.footer-menu.learn.items.2.text"),
          external: true,
          route: "https://docs.marinade.finance/marinade-protocol/security",
        },
      ],
    },
  ];
};
